import React, { useState } from 'react';

function validateAtom(atom) {
  if (atom.wrapper) {
    if (!atom.name) throw 'Atom wrapper declaration missing name field';
    atom.atoms.forEach(validateAtom);
  } else {
    ['component', 'name'].forEach((f) => {
      if (!atom[f]) throw `Atom declaration missing ${f} field`;
    });
  }
}

function renderAtom(atomProperties, moleculeProperties, atomComponents) {
  const atomName = `${moleculeProperties.name}.${atomProperties.name}`;
  const { eventName, bindings, eventManager } = moleculeProperties;
  const render = !atomProperties.renderIf || atomProperties.renderIf(bindings)

  if (atomProperties.wrapper && render) {
    const children = [];
    atomProperties.atoms.forEach((a) => renderAtom(a, moleculeProperties, children));
    const wrapped = <atomProperties.wrapper key={atomName} childElement={children} displayState={atomProperties?.displayState?.(bindings)} />;
    atomComponents.push(wrapped);
    return;
  }
  const { component: Atom, displayValue, displayState } = atomProperties;

  if (render) {
    atomComponents.push(
      <Atom
        key={atomName}
        name={atomName}
        eventManager={eventManager}
        bindings={bindings}
        eventName={eventName}
        displayState={displayState && displayState(bindings)}
        displayValue={displayValue && displayValue(bindings)}
      />
    );
  }
}

const Molecule = ({ atoms, type, template: Template }) => {
  atoms.forEach(validateAtom);
  const mol = (mol) => {
    const atomComponents = [];
    atoms.forEach((atom) => {
      renderAtom(atom, mol, atomComponents);
    });

    const refAttrs = {};
    if (mol._innerRef) {
      refAttrs.ref = mol._innerRef;
    }

    if (type === 'link' && mol.bindings.href) {
      return (
        <Template href={mol.bindings.href} target={mol.bindings.target || '_blank'} {...refAttrs} displayState={mol.displayState}>
          {atomComponents}
        </Template>
      );
    }
    if (type === 'button') {
      const { eventName, bindings, eventManager } = mol;
      const clickHandler = (e) => {
        e.stopPropagation();
        eventManager(eventName, bindings);
      };
      return (
        <Template {...refAttrs} displayState={mol.displayState} onClick={clickHandler}>
          {atomComponents}
        </Template>
      );
    }
    if (type === 'dropFiles') {
      const { eventName, bindings, eventManager } = mol;
      const [isHovered, setIsHovered] = useState(false);

      const onDrop = (event) => {
        stopEvent(event);
        const { files } = event.dataTransfer;
        eventManager(eventName, { ...bindings, value: files })
        setIsHovered(false);
      }

      const onDragOver = (event) => {
        stopEvent(event);
        setIsHovered(true);
      }

      const onDragLeave = (event) => {
        stopEvent(event);
        setIsHovered(false);
      }

      const stopEvent = event => {
        event.preventDefault();
        event.stopPropagation();
      };
      return (
        <Template
          {...refAttrs}
          displayState={mol.displayState}
          isHovered={isHovered}
          onDrop={onDrop}
          onDragLeave={onDragLeave}
          onDragOver={onDragOver}
        >
          <input
            onChange={({ target: { files } }) => eventManager(eventName, { ...bindings, value: files })}
            type="file"
            style={{ display: 'none' }}
            multiple="multiple"
          />
          {atomComponents}
        </Template >
      );
    }
    return (
      <Template {...refAttrs} displayState={mol.displayState}>
        {atomComponents}
      </Template>
    );
  };
  mol._appReactType = type;
  return mol;
};

export default Molecule;
